<nav class="side-nav">
    <ul class="menu">
        <li routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a>Home</a></li>
        <li><a>Search</a></li>
        <li><a>About</a></li>
        <li><a>Contact</a></li>
    </ul>
</nav>